// Helpers for the transaction list screens. Presentation only.
import dayjs from "dayjs";

// "2026-09-21" -> "Today" / "Yesterday" / "3 days ago" / "2w ago" / "4mo ago"
export const agoOf = (s) => {
  const d = dayjs(s);
  if (!d.isValid()) return "";
  const n = dayjs().startOf("day").diff(d.startOf("day"), "day");
  if (n < 0) return "Upcoming";
  if (n === 0) return "Today";
  if (n === 1) return "Yesterday";
  if (n < 7) return `${n} days ago`;
  if (n < 31) return `${Math.round(n / 7)}w ago`;
  return `${Math.round(n / 30)}mo ago`;
};

// Payment / status types shared by the sales screens (salesPaymentType)
export const SALES_PAYMENTS = [
  { v: 0, t: "Cash", tone: "cash" },
  { v: 1, t: "Credit", tone: "credit" },
  { v: 2, t: "UPI", tone: "upi" },
  { v: 3, t: "Card", tone: "card" },
];

// purchasePaymentType, as the purchase screens label it
export const PURCHASE_PAYMENTS = [
  { v: 0, t: "Cash", tone: "cash" },
  { v: 1, t: "Card", tone: "card" },
  { v: 2, t: "Bank", tone: "bank" },
  { v: 3, t: "Credit", tone: "credit" },
  { v: 4, t: "UPI", tone: "upi" },
];

// a POS bill is an ordinary sales invoice numbered in the "POS…" series
export const isPosBill = (entrynumber) => /^POS/i.test(String(entrynumber || ""));
